module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAKCAYAAACJxx+AAAAAp0lEQVQoU62QoQ4CMRBEpy0hEAR/g8IRHPLcbc+hIdgjweGR4HpdNAIH4hL+hq8YUpIjBc2qzebNTmYMsokxbkiOq6radWeTA6q6BzASkdV/gWTD9PLXom3bnlHVJwAvIrccCCFMnXPXBMxIXkjOrbULkgNr7Znkwxjj3ylUtQBwBHAH0AcwAVCLSPjEVNUlgFMSkFx77w9p/+qhaZqtc25YlmXd9fACpYNJZVxSJGEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/charter/screen_icon_moren.png
// module id = 6mdG
// module chunks = 1